module.exports = __webpack_public_path__ + "img/img-ordena.7a82b97a.webp";